/**
 * statCatalogue.js — the stat list the Team Settings picker renders.
 * 2026-09-19 (Phase 7A).
 *
 * SOURCE OF TRUTH IS backend/src/utils/gameStats.js. This is a display-only
 * mirror so the settings page can render groups and labels without a round
 * trip. The server validates every code on save and drops anything it does
 * not recognise, so a drift here can only ever show an option that silently
 * fails to save — never write a bad value into a team. If you add a stat,
 * add it there first, then here.
 */

export const STAT_GROUPS = Object.freeze([
  {
    key: 'scoring', label: 'Scoring',
    stats: [
      { code: 'goal',   label: 'Goals',   short: 'G', defaultOn: true },
      { code: 'assist', label: 'Assists', short: 'A', defaultOn: true },
    ],
  },
  {
    key: 'shots', label: 'Shots',
    stats: [
      { code: 'shot',         label: 'Shots on net',  short: 'SOG', defaultOn: true },
      { code: 'shot_missed',  label: 'Shots missed',  short: 'MS',  defaultOn: false },
      { code: 'shot_blocked', label: 'Blocked shots', short: 'BS',  defaultOn: false },
    ],
  },
  {
    key: 'faceoffs', label: 'Faceoffs',
    stats: [
      { code: 'faceoff_win',  label: 'Faceoffs won',  short: 'FOW', defaultOn: true },
      { code: 'faceoff_loss', label: 'Faceoffs lost', short: 'FOL', defaultOn: true },
    ],
  },
  {
    key: 'penalties', label: 'Penalties',
    stats: [
      { code: 'penalty',         label: 'Penalties',       short: 'PEN', defaultOn: true },
      { code: 'penalty_minutes', label: 'Penalty minutes', short: 'PIM', defaultOn: true },
    ],
  },
  {
    key: 'physical', label: 'Hits, blocks and turnovers',
    stats: [
      { code: 'hit',      label: 'Hits',      short: 'H',  defaultOn: false },
      { code: 'takeaway', label: 'Takeaways', short: 'TA', defaultOn: false },
      { code: 'giveaway', label: 'Giveaways', short: 'GA', defaultOn: false },
    ],
  },
  {
    key: 'goalie', label: 'Goaltending',
    stats: [
      { code: 'save',         label: 'Saves',         short: 'SV', defaultOn: false },
      { code: 'goal_against', label: 'Goals against', short: 'GA', defaultOn: false },
    ],
  },
  {
    key: 'stoppages', label: 'Stoppages',
    stats: [
      { code: 'icing',   label: 'Icings',   short: 'ICE', defaultOn: false },
      { code: 'offside', label: 'Offsides', short: 'OFF', defaultOn: false },
    ],
  },
]);

export const ALL_STATS = Object.freeze(STAT_GROUPS.flatMap(g => g.stats));
export const DEFAULT_TRACKED = Object.freeze(ALL_STATS.filter(s => s.defaultOn).map(s => s.code));
